module.exports = __webpack_public_path__ + "media/books/Books-Keepsake-61af28e6.jpg";